import React from 'react';
import {
  GradientDiv,
  CardContainer,
  SectionDiv,
  HeaderSection,
  TabSection,
  TabItem,
  BottomSection,
  ListTitle,
  ListSection,
  BorderDiv,
  ListBottomSection,
  ProjectDiv,
  Status,
  ProjectName,
  ProjectDetails,
  ProjectTitle
} from './style';
import ProjectIconAvatar from '../../../../../component/ProjectIconAvtar/projectIconAvtar';
import { ICON_COLORS, PROJECT_ICON_TYPE } from '../../../../../global/constants';
import { rootStore } from '../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import SVGIcon from '../../../../../assets/images/svg/SVGIcon';
import { SVGIconDiv } from '../../../../../component/viewCard/style';

const RightSection = () => {
  const { projectStore } = rootStore;
  const { createProjectInput } = projectStore;
  return (
    <SectionDiv>
      <GradientDiv />
      <CardContainer>
        <HeaderSection>
          {/* Project Name is passed temporary need to remove as it is set dynamic */}
          <ProjectDetails>
            {!createProjectInput?.icon && !createProjectInput?.name ? (
              <SVGIconDiv>
                <SVGIcon name='pie-chart-icon' width='20' height='20' viewBox='0 0 14 14' fill='var(--text-muted)' />
              </SVGIconDiv>
            ) : (
              <ProjectIconAvatar
                size={38}
                type={createProjectInput?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
                reference={createProjectInput?.icon?.reference || ''}
                backgroundColor={createProjectInput?.icon?.color ? ICON_COLORS[createProjectInput?.icon?.color] : ''}
                projectName={createProjectInput?.name}
                iconSize={20}
              />
            )}

            {/* passed static name for now */}
            <ProjectTitle>{createProjectInput?.name}</ProjectTitle>
          </ProjectDetails>
          <TabSection>
            <TabItem />
            <TabItem />
            <TabItem />
            <TabItem />
          </TabSection>
        </HeaderSection>
        <BottomSection>
          <ListSection>
            <ListTitle />
            <BorderDiv />
            <ListBottomSection>
              <ProjectDiv>
                <Status></Status>
                <ProjectName />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-390' />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-280' />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-170' />
              </ProjectDiv>
            </ListBottomSection>
          </ListSection>
          <ListSection>
            <ListTitle />
            <BorderDiv />
            <ListBottomSection>
              <ProjectDiv>
                <Status></Status>
                <ProjectName />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-170' />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-280' />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-390' />
              </ProjectDiv>
            </ListBottomSection>
          </ListSection>
          <ListSection>
            <ListTitle />
            <BorderDiv />
            <ListBottomSection>
              <ProjectDiv>
                <Status></Status>
                <ProjectName />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-170' />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-280' />
              </ProjectDiv>
              <ProjectDiv>
                <Status></Status>
                <ProjectName className='w-390' />
              </ProjectDiv>
            </ListBottomSection>
          </ListSection>
        </BottomSection>
      </CardContainer>
    </SectionDiv>
  );
};

export default observer(RightSection);
